import { connect } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { getOptionsHeadingText } from 'src/components/layouts/Standard/copy';
import { selectOptions } from 'src/redux/basket/selectors';
import { actions as basketActions } from 'src/redux/basket/slice';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/product/selectors';
import type { AppThunkDispatch } from 'src/redux/store';
import type {
  ProductOptionsDrawerDispatchProps,
  ProductOptionsDrawerStateProps,
} from './ProductOptionsDrawer';
import { ProductOptionsDrawer } from './ProductOptionsDrawer';

const mapStateToProps = (state: ReduxApplicationState): ProductOptionsDrawerStateProps => {
  const product = selectProduct(state);

  return {
    heading: getOptionsHeadingText(
      product.purchasable,
      selectOptions(state).length > 0,
      product.specialFeatures.personalisable,
    ),
    images: product.images,
    isOpen: state.basket.isOptionsExpanded,
    showValidationErrors: state.basket.shouldShowValidationErrors,
  };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ProductOptionsDrawerDispatchProps => {
  return {
    onClose: () => dispatch(basketActions.setOptionsExpanded({ expanded: false })),
    onVisible: () => {
      sendGAEvent({
        event: 'custom_event',
        event_category: 'Product Personalisation',
        event_action: 'Impression',
        event_label: 'Initial Impression',
      });
    },
  };
};

export const ProductOptionsDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductOptionsDrawer);
